<template>
  <div class="rodape-redes-sociais">
    <span class="rodape-redes-sociais__eyebrow">Redes sociais</span>
    <div class="rodape-redes-sociais__lista">
      <a
        v-for="rede in redes"
        :key="rede.url"
        class="rodape-redes-sociais__link"
        :class="{ 'rodape-redes-sociais__link--inter': isInterTheme }"
        :href="rede.url"
        target="_blank"
        rel="noopener"
        :aria-label="rede.nome"
        :data-ua="rede.dataUa"
      >
        <img :src="rede.icone" :alt="rede.nome" width="18" height="18">
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import iconFacebook from '@/assets/images/icons/facebook.svg';
import iconInstagram from '@/assets/images/icons/instagram.svg';
import iconLinkedin from '@/assets/images/icons/linkedin-in.svg';
import theme from '@/services/ThemeService';

const isInterTheme = computed(() => theme.isInterTheme());

const redes = [
  {
    nome: 'Instagram',
    icone: iconInstagram,
    url: 'https://www.instagram.com/acerto_negocie',
    dataUa: 'click-nav-rodape-social-instagram',
  },
  {
    nome: 'Facebook',
    icone: iconFacebook,
    url: 'https://www.facebook.com/acertonegocie',
    dataUa: 'click-nav-rodape-social-facebook',
  },
  {
    nome: 'LinkedIn',
    icone: iconLinkedin,
    url: 'https://www.linkedin.com/company/acertonegocie/',
    dataUa: 'click-nav-rodape-social-linkedin',
  },
];
</script>

<style scoped lang="scss">
@use "@/assets/styles/vars" as *;

.rodape-redes-sociais {
  display: flex;
  flex-direction: column;
  gap: $space-xxs;
}

.rodape-redes-sociais__eyebrow {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-77, #777);
}

.rodape-redes-sociais__lista {
  display: flex;
  gap: $space-xxxs;
}

.rodape-redes-sociais__link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: var(--neutral-FF, #fff);
  border: 1px solid var(--acerto-colors-green-700, #1f7a40);

  &.rodape-redes-sociais__link--inter {
    border-color: var(--primary-color-normal);
  }
}
</style>
